import React from 'react';
import PropTypes from 'prop-types';
import { getDateString } from '../../utilities';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import Button from 'Components/Button';
import styles from './PaymentPlanDetails.scss';

const createExpirationDate = () => {
  const dateObj = new Date();
  dateObj.setFullYear(dateObj.getFullYear() + 1);
  return getDateString(dateObj, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

const PaymentPlanDetails = ({ changePlanCallback, plan }) => (
  <div className="PaymentPlanDetails">
    <div className="PaymentPlanDetails__label">Selected Plan</div>

    <div className="PaymentPlanDetails__header">
      <div className="PaymentPlanDetails__header-text">
        <ConnectedFormattedMessage id={plan.titleId} />
      </div>
      {changePlanCallback && (
        <button
          type="button"
          className="u-text-link"
          onClick={changePlanCallback}
        >
          Change
        </button>
      )}
    </div>
    <dl className="PaymentPlanDetails__list">
      <div className="PaymentPlanDetails__item">
        <dt>Educator seats</dt>
        <dd>{plan.seats.educators}</dd>
      </div>

      <div className="PaymentPlanDetails__item">
        <dt>Student seats</dt>
        <dd>{plan.seats.students}</dd>
      </div>

      <div className="PaymentPlanDetails__item">
        <dt>Renewal</dt>
        <dd>{createExpirationDate()}</dd>
      </div>

      <div className="PaymentPlanDetails__item PaymentPlanDetails__item--price">
        <dt>Annual cost</dt>
        <dd>${plan.computedPrice}</dd>
      </div>
    </dl>
  </div>
);

PaymentPlanDetails.propTypes = {
  plan: PropTypes.object,
  changePlanCallback: PropTypes.func,
};

export default PaymentPlanDetails;
